var exports = {
  "y": "InterestOnboardingGate.module__app___UHJ6Tk",
  "n": "InterestOnboardingGate.module__screen___UHJ6Tk",
};

module.exports = exports;
